import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { JooserBooking } from './use-jooser-bookings';

type Variables = { id: number };
type Response = JooserBooking;

export const useJooserBooking = createQuery<Response, Variables, AxiosError>({
  queryKey: ['jooser/booking'],
  fetcher: ({ id }) => {
    return client
      .get(`v2/customers/me/jooser/bookings/${id}`)
      .then((response) => {
        return response.data.data;
      });
  },
});
